import { useEffect } from 'react';
import { logout } from '../../reducers/auth-slice';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../reducers';
import { AppThunkDispatch } from '../../util/store';

const Logout = () => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);
  const checkoutId = searchParams.get('checkoutId');

  const globalAuthState = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (!globalAuthState.isLoggedIn) {
      const to = !checkoutId ? '/' : `/?checkoutId=${checkoutId}`;

      history.push(to);
    }
  }, [history, globalAuthState.isLoggedIn]);

  return null;
};

export default Logout;
